import React, { Component } from "react"
import { Button, Modal, Spinner, Col, Row, Table, Container } from "react-bootstrap"
import OrderResultRecord from "../../api/OrderResults/OrderResultModel/OrderResultRecord"
import { Subscription, BehaviorSubject, of, concat } from "rxjs"
import { distinctUntilChanged, switchMap, map, catchError } from "rxjs/operators"
import { toast } from "react-toastify"
import ColumnHeaderFilter from "../ColumnHeaderFilter"
import ColumnFilter from "../../api/Randoms/RandomsModel/ColumnFilter"
import FormatDate from "../../formatters/FormatDate"
import TestEventUpdateData from "../../api/OrderResults/OrderResultModel/TestEventUpdateData"
import SearchField from "../../api/SearchField"
import SearchBar from "../SearchBar"
import { Filter, Sort } from "../../api/GridRequest"
import FormatSSN from "../../formatters/FormatSSN"
import { TestToMergeGetObservable, MergeTest } from "../../api/OrderResults/TestToMergeGet"
import TestToMergeViewModel from "../../api/OrderResults/OrderResultModel/TestToMergeRecord"
import { TestToMergeRecord } from "../../api/OrderResults/OrderResultModel/TestToMergeRecord"
import TablePagination from "../TablePagination"
import ConfirmationModal from "../ConfirmationModal"

interface SearchTestToMergeProps {
  details: OrderResultRecord
  onHide: () => void
}

interface SearchTestToMergeState {
  data?: TestToMergeViewModel
  loading: boolean
  searchFields: SearchField[]
  selectedTest?: TestToMergeRecord
  dataSaving: boolean
  showMergeFullCopyConfirmation: boolean
  showMergeUpdateEmptyConfirmation: boolean
}
const DefaultSearchFields: SearchField[] = [
  { ID: "AllPersonnelIDs", Name: "All Personnel IDs" },
  { ID: "AlternateID", Name: "Alternate ID" },
  { ID: "DriverID", Name: "Driver ID" },
  { ID: "EmployerID", Name: "Employer ID" },
  { ID: "SSN", Name: "SSN" },
  { ID: "FirstName", Name: "First Name" },
  { ID: "LastName", Name: "Last Name" },
  { ID: "FullName", Name: "Full Name" },
  { ID: "SampleID", Name: "Sample ID" }
]
interface TesToMergeSearchParams {
  pageNumber: number
  sort: Sort
  filters: Filter[]
  search: { field: string, text: string }
}
interface ResultColumn {
  ID: string
  Name: string
}
const ResultColumns: ResultColumn[] = [
  { ID: "ID", Name: "ID" },
  { ID: "Name", Name: "Name" },
  { ID: "CollDate", Name: "Coll Date" },
  { ID: "ReferenceID", Name: "Reference ID" },
  { ID: "Reason", Name: "Reason" },
  { ID: "Type", Name: "Type" },
  { ID: "Result", Name: "Result" },
  { ID: "Status", Name: "Status" },
  { ID: "Company", Name: "Company" },
]

const PageSize = 20
export default class SearchTestToMerge extends Component<SearchTestToMergeProps, SearchTestToMergeState> {
  subscription?: Subscription
  mergeSubscription?: Subscription
  pageSubscription?: Subscription
  state: SearchTestToMergeState = {
    data: undefined, loading: false, searchFields: DefaultSearchFields,
    selectedTest: undefined, dataSaving: false, showMergeFullCopyConfirmation: false, showMergeUpdateEmptyConfirmation: false
  }

  page$ = new BehaviorSubject<TesToMergeSearchParams>({
    pageNumber: 1,
    sort: { column: "", order: "" },
    filters: [],
    search: { field: "", text: "" }
  })

  componentDidMount() {
    this.pageSubscription = this.page$.pipe(
      distinctUntilChanged(),
      switchMap(params => concat(
        of({ loading: true }),
        TestToMergeGetObservable(params.pageNumber, PageSize, params.sort, params.filters, params.search, this.props.details.TestDetailID, this.props.details.TestType).pipe(
          map((result: TestToMergeViewModel) => ({ data: result, loading: false })))
      )
      )
    ).subscribe(
      (newState: { loading: boolean, data?: TestToMergeViewModel }) => {
        if (newState.data) {
          this.setState({ loading: newState.loading, data: newState.data })
        } else {
          this.setState({ loading: newState.loading })
        }
      },
      (error: string) => {
        this.setState({ loading: false })
        toast.error(error)
      }
    )
  }


  componentWillUnmount() {
    this.mergeSubscription && this.mergeSubscription.unsubscribe()
    this.pageSubscription && this.pageSubscription.unsubscribe()
  }


  onCancel = () => {
    this.props.onHide()

  }
  confirmMergeFullCopy = () => {
    this.setState({ showMergeFullCopyConfirmation: true })
  }
  onMergeFullCopy = () => {

    this.setState({ showMergeFullCopyConfirmation: false })
    if (this.state.selectedTest) {
      this.mergeTest(1)
      //this.props.onHide()
      return
    }
    this.props.onHide()
  }
  confirmMergeUpdateEmpty = () => {
    this.setState({ showMergeUpdateEmptyConfirmation: true })
  }
  onMergeUpdateEmpty = () => {
    this.setState({ showMergeUpdateEmptyConfirmation: false })
    if (this.state.selectedTest) {
      this.mergeTest(2)
      //this.props.onHide()
      return
    }
    this.props.onHide()
  }
  createMergeParams(mergeMode: number) {
    return {
      TestDetailID: this.props.details.TestDetailID,
      MergeTestDetailID: this.state.selectedTest?.TestDetailID || 0,
      MergeMode: mergeMode,
      KeepReleased: false
    }
  }
  mergeTest(mergeMode: number) {
    this.setState({ dataSaving: true, loading: false })
    const updateData = this.createMergeParams(mergeMode)
    this.mergeSubscription && this.mergeSubscription.unsubscribe()
    this.mergeSubscription = MergeTest(updateData).subscribe(
      data => {
        this.setState({ dataSaving: false })
        toast.success(data),
          // this.onSubmit()
          this.props.onHide()
      },
      (error) => {
        toast.error(error?.errorData?.message || error.message)
        this.setState({ dataSaving: false })
      },
      () => {
        this.setState({ dataSaving: false })
        this.props.onHide()
      }
    )

  }
  sortGrid(column: string, order?: string) {
    const newSort = { column: column, order: order || "" }
    this.page$.next({ ...this.page$.value, sort: newSort })
  }

  filterGrid(column: string, items: string[]) {
    const filters = [...this.page$.value.filters]
    const filter = { column: column, values: items }
    let index = filters.findIndex(item => item.column === filter.column)
    if (index >= 0) {
      filters[index] = filter
    } else {
      filters.push(filter)
    }

    this.page$.next({ ...this.page$.value, pageNumber: 1, filters: filters })
  }
  onSearch = (field: string, text: string) => {
    this.page$.next({ ...this.page$.value, pageNumber: 1, search: { field: field, text: text } })
  }
  formatSearchString = (ID: string, value: string): string => {
    return ID === "SSN" ? FormatSSN(value) : value
  }
  pageChanged = (pageNumber: number) => {
    this.page$.next({ ...this.page$.value, pageNumber: pageNumber })
  }
  filterItems = (columnName: string): any[] => {
    if (columnName === "ID") {
      return this.state.data?.ID || []
    }
    if (columnName === "Name") {
      return this.state.data?.Name || []
    }
    if (columnName === "DateCollected") {
      return this.state.data?.DateCollected || []
    }
    if (columnName === "Reason") {
      return this.state.data?.Reason || []
    }
    if (columnName === "Type") {
      return this.state.data?.Type || []
    }
    if (columnName === "Result") {
      return this.state.data?.Result || []
    }
    if (columnName === "Status") {
      return this.state.data?.Status || []
    }
    if (columnName === "Company") {
      return this.state.data?.Company || []
    }
    return []
  }
  renderHeaderColumn = (columnName: string, title: string) => {
    const sort = this.page$.value.sort
    return <th>
      {this.state.data
        ? <ColumnHeaderFilter title={title}
          sort={sort.column === columnName ? sort.order === "asc" ? "asc" : "desc" : undefined}
          items={this.filterItems(columnName)?.filter(item => !!item) || []}
          filteredItems={this.page$.value.filters.find(item => item.column === columnName)?.values || []}
          onSort={(order?: string) => this.sortGrid(columnName, order)}
          onFilter={(items: string[]) => this.filterGrid(columnName, items)} />
        : title.toUpperCase()}
    </th>
  }

  selectTest = (row: TestToMergeRecord) => {
    this.setState({ selectedTest: row })
  }

  renderRows = () => {
    if (this.state.data?.Records && this.state.data?.Records.length) {
      return this.state.data.Records.map((row: TestToMergeRecord, i: number) =>
        <tr key={i} onClick={() => this.selectTest(row)}>
          <td>{row.ID}</td>
          <td>{row.Name}</td>
          <td>{FormatDate(row.DateCollected)}</td>
          <td>{row.TestReasonCode}</td>
          <td>{row.SampleTypeCode}</td>
          <td>{row.EventResultCode}</td>
          <td>{row.EventStatusCode}</td>
          <td>{row.Company}</td>
        </tr>)
    } else {
      return <tr><td colSpan={8}>No Records Found</td></tr>
    }
  }

  render() {
    const selectedTest = this.state.selectedTest
    const fullCopyConfirmationText = "Please be aware all original test information will be retained. All merge data will overwrite the fields on the existing test. Press 'Continue' to merge the two records or 'Cancel' to return."
    const updateEmptyConfirmationText = "Please be aware all original test information will be retained. Any merge data will be lost except for values that can be populated to null fields on the original test. Press 'Continue' to merge the two records or 'Cancel' to return. "

    const content = <>
      <Modal.Header>
        <Modal.Title className="text-uppercase">Merge</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {<Container>
          <Row className="pb-2">
            <Col>
              <SearchBar onSearch={this.onSearch} searchFields={this.state.searchFields || []} formatValue={this.formatSearchString} allowBlank placeholder="Select" />
            </Col>
          </Row>
          <Row className="d-flex justify-content-center">
            <Col md="auto">
            </Col>
            <Col md="auto">
            </Col>
          </Row>
        </Container>}
        {<Container>
          <Row>
            <Col>
              <Table bordered responsive>
                <thead>
                  <tr >
                    {this.renderHeaderColumn("ID", "ID")}
                    {this.renderHeaderColumn("Name", "Name")}
                    {this.renderHeaderColumn("DateCollected", "Coll Date")}
                    {this.renderHeaderColumn("Reason", "Reason")}
                    {this.renderHeaderColumn("Type", "Type")}
                    {this.renderHeaderColumn("Result", "Result")}
                    {this.renderHeaderColumn("Status", "Status")}
                    {this.renderHeaderColumn("Company", "Company")}



                  </tr>
                </thead>
                <tbody>
                  {
                    this.state.loading ?
                      <tr>
                        <td className="text-center" colSpan={8}>
                          <Spinner animation="border" variant="secondary" />
                        </td>
                      </tr> : this.renderRows()
                  }
                </tbody>
              </Table>
            </Col>
          </Row>
          {this.state.data ?
            <Row>
              <Col>
                <span className="total-records">Total records: {this.state.data.Total}</span>
                <TablePagination pageNumber={this.page$.value.pageNumber} pages={this.state.data.Pages} onChange={this.pageChanged} />
              </Col>
            </Row> : undefined}
          {(this.state.data && this.state.selectedTest) ?
            <Row>
              <Col>
                <Row>
                  <Col>Donor ID: </Col><Col>{this.state.selectedTest.ID || ""}</Col>
                  <Col>Reason For Test: </Col><Col>{this.state.selectedTest.TestReason || ""}</Col>
                </Row>
                <Row>
                  <Col>First Name: </Col><Col>{this.state.selectedTest.FirstName}</Col>
                  <Col>Sample Type: </Col><Col>{this.state.selectedTest.SampleType || ""}</Col>
                </Row>
                <Row>
                  <Col>Last Name: </Col><Col>{this.state.selectedTest.LastName}</Col>
                  <Col>Federal Regulated: </Col><Col>{this.state.selectedTest.DOT ? "Yes" : "No"}</Col>
                </Row>
              </Col>
            </Row> : undefined
          }
        </Container>}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" className="px-4" onClick={this.onCancel}>Cancel</Button>
        <Button variant="primary" className="px-4" onClick={this.confirmMergeFullCopy} disabled={!this.state.selectedTest}>Merge (Full copy)</Button>
        <Button variant="primary" className="px-4" onClick={this.confirmMergeUpdateEmpty} disabled={!this.state.selectedTest}>Merge (Update Empty)</Button>
      </Modal.Footer>
      <ConfirmationModal show={this.state.showMergeFullCopyConfirmation}
        title="CONFIRM MERGE"
        textTitle="Are you sure you want to merge?"
        text={fullCopyConfirmationText}
        onConfirm={this.onMergeFullCopy}
        onHide={() => this.setState({ showMergeFullCopyConfirmation: false })} />

      <ConfirmationModal show={this.state.showMergeUpdateEmptyConfirmation}
        title="CONFIRM MERGE"
        textTitle="Are you sure you want to merge?"
        text={updateEmptyConfirmationText}
        onConfirm={this.onMergeUpdateEmpty}
        onHide={() => this.setState({ showMergeUpdateEmptyConfirmation: false })} />
    </>

    return <>
      {
        <Modal.Dialog size="xl">{content}</Modal.Dialog>}
      {<Modal backdrop="static" show size="xl">{content}</Modal>}
    </>
  }
}
